import { Button, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Chrome, Globe, Monitor, ArrowRight, Shield, Sparkles, FolderSync } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import ThreeBackground from './ThreeBackground';

const { Text } = Typography;

const platforms = [
    {
        icon: <Chrome size={20} />,
        name: "Chrome",
        link: "https://chromewebstore.google.com/detail/page-notes-pro/ekkbhlfdgnalobhgehklnlleecbhglil?authuser=0&hl=en",
        primary: true
    },
    {
        icon: <Globe size={20} />,
        name: "Firefox",
        link: "https://addons.mozilla.org/en-US/firefox/addon/page-notes-live/",
    },
    {
        icon: <Monitor size={20} />,
        name: "Web App",
        link: "/notes",
        internal: true
    }
];

const highlights = [
    { icon: <Shield size={16} />, text: "End-to-End Encrypted" },
    { icon: <Sparkles size={16} />, text: "AI-Powered" },
    { icon: <FolderSync size={16} />, text: "Cross-Device Sync" },
];

export default function HeroSection() {
    const navigate = useNavigate();
    const { isDark } = useTheme();

    return (
        <div className="hero-section">
            <div className="hero-background">
                <ThreeBackground />
            </div>
            <div className="hero-content">
                {/* Trust badge */}
                <div className="hero-badge">
                    <span className="badge-icon">✨</span>
                    <span>Trusted by 5,000+ users</span>
                </div>
                
                <h1 className="hero-title">
                    Your Notes,<br />Wherever You Browse
                </h1>
                
                <p className="hero-subtitle">
                    The smart note-taking companion that lives in your browser. Attach rich notes to any webpage, organize with folders &amp; tags, sync across devices, and let AI help you think — all with end-to-end encryption.
                </p>

                {/* Highlight chips */}
                <div className="hero-highlights">
                    {highlights.map((h, i) => (
                        <div key={i} className="highlight-chip">
                            {h.icon}
                            <span>{h.text}</span>
                        </div>
                    ))}
                </div>

                {/* Platform download buttons */}
                <div className="hero-platforms">
                    <Text className="platforms-label">Get the extension:</Text>
                    <div className="platform-buttons">
                        {platforms.map((p, i) => (
                            <a
                                key={i}
                                href={p.link}
                                target={p.internal ? "_self" : "_blank"}
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    if (p.internal) {
                                        e.preventDefault();
                                        navigate(p.link);
                                    }
                                }}
                            >
                                <Button
                                    type={p.primary ? "primary" : "default"}
                                    size="large"
                                    className={`platform-btn ${p.primary ? 'primary' : ''}`}
                                    icon={p.icon}
                                >
                                    {p.name}
                                </Button>
                            </a>
                        ))}
                    </div>
                </div>

                {/* Secondary CTA */}
                <div className="hero-secondary">
                    <Button 
                        type="link" 
                        className="learn-more-link"
                        onClick={() => {
                            document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        See all features <ArrowRight size={16} />
                    </Button>
                </div>
            </div>
        </div>
    );
}
